"use client";
import { jsx } from "react/jsx-runtime";
import { DropdownUserItem } from "../../primitive-dropdown/dropdown-user-item.js";
import { GenericDropdown } from "./generic-dropdown.js";
function UsersDropdown({ users, ...props }) {
    const options = users.map((option)=>({
            value: option.value,
            label: option.name,
            element: (elementProps)=>/*#__PURE__*/ jsx(DropdownUserItem, {
                    user: option,
                    ...elementProps
                })
        }));
    return /*#__PURE__*/ jsx(GenericDropdown, {
        ...props,
        options: options
    });
}
export { UsersDropdown };
